"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m16.22 13.574.019.255c.05.848-.076 1.673-.323 2.482a11 11 0 0 1-.974 2.212c-.03.053-.029.09.002.142.553.967-.086 2.21-1.194 2.326a1.57 1.57 0 0 1-1.741-1.668 1.575 1.575 0 0 1 1.702-1.454c.045.005.07-.004.093-.045.455-.814.826-1.66 1.005-2.581.213-1.103.102-2.162-.424-3.167-.033-.065-.07-.085-.141-.085-.58.003-1.16-.006-1.74.005a.476.476 0 0 1-.501-.499c.011-.585.003-1.17.005-1.756 0-.056-.013-.09-.067-.118a4.6 4.6 0 0 0-2.536-.518c-.828.062-1.606.306-2.355.649-.289.131-.567.286-.85.428-.056.028-.071.061-.069.123.026.7-.265 1.223-.893 1.534-.936.462-2.065-.142-2.219-1.174a1.56 1.56 0 0 1 1.21-1.772c.39-.088.764-.03 1.113.168.047.027.08.028.128 0 .836-.474 1.71-.861 2.646-1.095a6.8 6.8 0 0 1 2.247-.192l.063.004c-.024-.027-.038-.045-.055-.062Q9.563 6.91 8.758 6.1c-.042-.041-.076-.048-.13-.031a1.567 1.567 0 0 1-2.01-1.289A1.563 1.563 0 0 1 7.95 3.017c1.128-.165 2.053.909 1.723 2.002-.02.062-.01.098.035.144q1.818 1.815 3.633 3.632a.19.19 0 0 0 .145.062q.585-.004 1.171-.001c.307 0 .488.181.489.488q.001.585-.001 1.172c0 .056.014.098.056.139a2547 2547 0 0 1 3.638 3.638c.043.044.078.053.137.035a1.567 1.567 0 0 1 2.002 1.749 1.564 1.564 0 0 1-1.564 1.32 1.566 1.566 0 0 1-1.537-1.352 1.66 1.66 0 0 1 .053-.687c.008-.03 0-.079-.02-.1q-.826-.83-1.655-1.657c-.006-.006-.013-.01-.036-.027",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SvgFileIcon24.js.map